/**
 * Sprint 168 — La cuenta no es el recibo.
 *
 * El 28/10/2026 la Mesa 1 (#442, $1,320) se quedó abierta toda la tarde: a las 4:13 pm la dueña tocó
 * "Ver ticket" → "Imprimir ticket", le dio el papel al cliente, marcó la mesa como entregada y nunca
 * tocó "Cobrar". La ventana del ticket decía **"Venta registrada"** (se escribió para mostrarse
 * DESPUÉS de cobrar y se reusó en "Ver ticket") y el papel era idéntico al recibo de una venta pagada.
 * Para ella, imprimirlo fue cerrar la cuenta.
 *
 * Imprimir la cuenta antes de cobrar es lo normal en un restaurante; lo que estaba mal es que el
 * sistema la llamara recibo. Aquí vive la regla que comparten el papel, la ventana y la mesa.
 */

/** Minutos con la cuenta entregada y sin cobrar antes de que el sistema lo recuerde en todas las pantallas. */
export const MINUTOS_AVISO_CUENTA = 15;

/**
 * ¿Este pedido todavía no está cobrado (o no completo)? Es una cuenta, no un recibo.
 *
 * - Un pedido `pagado` SIN pagos guardados cuenta como cobrado (ventas viejas, de antes de que todo
 *   cobro dejara su renglón): reimprimir su ticket no puede convertirlo en "cuenta".
 * - Un pedido `pagado` al que después le agregaron algo (Sprints 141/146: "agréguele un refresco")
 *   sigue `pagado` pero le falta dinero: eso SÍ es cuenta (auditoría `cyber` S168, H-1).
 */
export function sinCobrar(p: { estado: string; total: number; pagos?: ReadonlyArray<{ monto: number }> | null }): boolean {
  if (p.estado === 'cancelado') return false;
  const pagos = p.pagos ?? [];
  if (p.estado === 'pagado' && pagos.length === 0) return false;
  return pagos.reduce((s, x) => s + x.monto, 0) < p.total;
}

/** Minutos desde que se entregó la cuenta; `null` si no se ha entregado. */
export function minutosConCuenta(fechaCuentaSolicitada: string | Date | null | undefined, ahora: number = Date.now()): number | null {
  if (!fechaCuentaSolicitada) return null;
  const t = new Date(fechaCuentaSolicitada).getTime();
  return Number.isFinite(t) ? Math.max(0, Math.floor((ahora - t) / 60_000)) : null;
}
